const state = {
	projectsByText: [],
	projectsByTool: [],
	projectsByCertification: [],
	projectsByCompany: [],
	projectsByOwner: [],
	projectsByBusinessContactManager: [],
	projectsByDeliveryContactManager: [],
	projectsByRelatedOffers: [],
	word: '',
	showResults: false
}

const getters = {
	getGlobalSearchResult: (state) => (name) => {
		return state[name]
	},
	getGlobalSearchResultsLength(state) {
		let lengthOfResults = 0
		for (const field in state) {
			if (field !== 'word' && field !== 'showResults' && field !== 'top5Projects') {
				lengthOfResults += state[field].length
			}
		}

		return lengthOfResults;
	},
	hideByDefault(state) {

		return state.projectsByText.length > 0
	},
	isFieldSelected: (state) => (name) => {
		let lengthOfResults = 0
		for (const field in state) {
			if (field !== name && field !== 'word' && field !== 'showResults') {
				lengthOfResults += state[field].length
			}
		}

		return lengthOfResults === 0;
	}
}

const actions = {
	setGlobalSearchResult({commit}, {resultName, payload}) {
		commit('changeGlobalSearchResult', {resultName, payload})
	},
	resetGlobalSearch({commit}) {
		commit('emptyGlobalSearch')
	},
}

const mutations = {
	changeGlobalSearchResult(state, payload) {
		state[payload.resultName] = payload.payload;
	},
	emptyGlobalSearch(state) {
			state.projectsByText = [],
			state.projectsByTool = [],
			state.projectsByCertification = [],
			state.projectsByCompany = [],
			state.projectsByOwner = [],
			state.projectsByBusinessContactManager = [],
			state.projectsByDeliveryContactManager = [],
			state.offers = [],
			state.word = "",
			state.showResults = false
	},
}

export default {state, getters, actions, mutations};
